import { API_URL, CONSULTANT_API_URL } from '../constants/config'
import { query } from './utilities'
import { request } from 'application/services/consultant/config'
import { checkConsultant } from '../helpers'
import globals from 'application/constants/globals'

export const FetchFinAppStatusService = (
  opportunityId: string,
  finAppNumber: string,
  headers: any,
  httpVerb: any
) => {

  if (checkConsultant()) {
    return request(
      `${CONSULTANT_API_URL}/Opportunity/${opportunityId}/finappstatus/${finAppNumber}`,
      headers,
      httpVerb
    )
  } else {
    let brand = globals.brand && globals.brand.toLowerCase()
    return query(`${API_URL}/Opportunity/${opportunityId}/finappstatus/${finAppNumber}/${brand}`)
  }
}
